

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// getAllstakeNowSections
// GETALLSTAKENOWSECTIONS
const GETALLSTAKENOWSECTIONS= createAsyncThunk(
  "getAllstakeNowSections/getAllstakeNowSections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllstakeNowSectionsSlice = createSlice({
  name: "getAllstakeNowSectionsSlice",
  initialState: {
    PublishPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GETALLSTAKENOWSECTIONS.fulfilled, (state, action) => {
      state.getAllstakeNowSections = {
        ...state.getAllstakeNowSections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTAKENOWSECTIONS.pending, (state, action) => {
      state.getAllstakeNowSections = {
        ...state.getAllstakeNowSections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTAKENOWSECTIONS.rejected, (state, action) => {
      state.getAllstakeNowSections = {
        ...state.getAllstakeNowSections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllstakeNowSectionsAction = {
    GETALLSTAKENOWSECTIONS,
};

export { getAllstakeNowSectionsAction };
export default getAllstakeNowSectionsSlice.reducer;
